export const numberOrZero = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const normalizeColorValue = (value, fallback = "#000000") => {
  if (!value || typeof value !== "string") return fallback;

  const trimmed = value.trim();
  const hexColorRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

  if (hexColorRegex.test(trimmed)) return trimmed;
  return fallback;
};